import { render, staticRenderFns } from "./tabLocalService.vue?vue&type=template&id=4b1b1f56&"
import script from "./tabLocalService.vue?vue&type=script&lang=js&"
export * from "./tabLocalService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b1b1f56')) {
      api.createRecord('4b1b1f56', component.options)
    } else {
      api.reload('4b1b1f56', component.options)
    }
    module.hot.accept("./tabLocalService.vue?vue&type=template&id=4b1b1f56&", function () {
      api.rerender('4b1b1f56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirImport/components/booking/tabs/tabLocalService.vue"
export default component.exports